import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Card } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  body: {
    background: theme.palette.bgElements,
    minHeight: '50vh',
    padding: '10px 10px'
  },
  itemWrap: {
    fontWeight: 500
  },
  itemLabel: {
    fontWeight: 200
  }
}));

function Booking(props) {
  const { data, themeMode } = props;
  const classes = useStyles();

  if (data !== null) {
    return (
      <div className="table-responsive">
        <table
          className={clsx(
            'table',
            themeMode === 'night' && 'table-pts-night',
            themeMode === 'day' && 'table-pts-day',
            'text-nowrap',
            'mb-0'
          )}>
          <thead>
            <tr>
              <th className="bg-white">Booking ID</th>
              <th className="bg-white">Booking Date</th>
              <th className="bg-white text-center">Release Date</th>
              <th className="bg-white text-center">Type</th>
              <th className="bg-white text-center">Is Bondable</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => {
              return (
                <tr key={idx}>
                  <td>{row.BookingID}</td>
                  <td>
                    {row.BeginDate
                      ? moment(row.BeginDate).format('MM/DD/YYYY, h:mm a')
                      : ''}
                  </td>
                  <td>
                    {row.ActualReleaseDate
                      ? moment(row.ActualReleaseDate).format(
                          'MM/DD/YYYY, h:mm a'
                        )
                      : ''}
                  </td>
                  <td>{row.BookingType}</td>
                  <td className="text-center">
                    <div
                      className={clsx(
                        'badge',
                        row.IsBondDenied === false &&
                          'bg-neutral-success text-success',
                        row.IsBondDenied === true &&
                          'bg-neutral-danger text-danger',
                        row.IsBondDenied === null &&
                          'bg-neutral-danger text-danger'
                      )}>
                      {row.IsBondDenied === false ? 'Yes' : 'No'}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <Card className="card-box bg-neutral-warning border-1 card-border-top border-warning text-center p-3">
        <h4 style={{ marginBottom: 0, color: 'black' }}>
          Sorry, no bookings found.
        </h4>
      </Card>
    );
  }
}

export default Booking;
